import React, {useEffect} from "react";
import * as queryString from 'query-string';
import {Container} from "react-bootstrap";
import {Window} from '../../model/CustomModel';

declare var window: Window;
const AppleCallbackComponent =
    (props: any) => {
        const location = props.location;
        const search = queryString.parse(location.hash);
        //console.log(location.hash);
        useEffect(() => {
            const code = search.code,token=search.id_token;
            const param={id_token: token,code: code};
            const query=JSON.stringify(param);
            console.log(`${process.env.REACT_APP_VAR}`);
            console.log(`app set address query=${query}`);
            try {
                window.Android.setAppleToken(query);
            }catch (e){
                console.error('android가 아님');
            }

        },[search]);
        return (
            <Container>
            <div className="bloc l-bloc" id="bloc-0">
                <div>애플 로그인 성공</div>
            </div>
            </Container>
        );
    };

export default AppleCallbackComponent;
